import { Component, ElementRef, ViewChild } from '@angular/core';
import { Events, NavController, NavParams } from 'ionic-angular';
import { AnimationService, AnimationBuilder } from 'css-animator';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";
import { GridBoxPage } from "../../pages/grid-box/grid-box";
import { Detail } from "../../pages/detail/detail";

@Component({
  selector: 'header-component',
  templateUrl: 'header.html',
  inputs: ['title']
})
export class HeaderComponent {
  @ViewChild('searchbar') searchbar: ElementRef;
  @ViewChild('titleText') titleText: ElementRef;
  public title: string;
  private searchword: string;
  private searchbarHidden: boolean = false;
  private animator: AnimationBuilder;
  private showSpinner: boolean = false;

  constructor(public navCtrl: NavController,
    public events: Events,
    public navParams: NavParams,
    animationService: AnimationService,
    private _ebsWebService: EbsWebService,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals) {
    this.animator = animationService.builder();
    this.animator.setDuration(300);
  }

  ngAfterViewInit(): void {
    this.searchbarHidden = !this._ebsWebServiceGlobals.getShowGeneralSearch();
  }
  /*
  searchToggle() {
    let that = this;
    this.animator.reset(this.searchbar.nativeElement);
    this.animator.reset(this.titleText.nativeElement);
    if (this.searchbarHidden) {
      this.animator.setType('fadeOutDown').hide(this.titleText.nativeElement).then(function(){
        that.animator.setType('fadeInDown').show(that.searchbar.nativeElement).then(function(){
          that.searchbarHidden=false;
        });
      });
    } else {
      this.animator.setType('fadeOutUp').hide(this.searchbar.nativeElement).then(function(){
        that.searchbarHidden=true;
        that.animator.setType('fadeInUp').show(that.titleText.nativeElement);
      });
    }
  }
  **/

  searchToggle() {
    if (this.searchbarHidden) {
      this.searchbarHidden = false;
    } else {
      this.searchbarHidden = true;
    }
  }


  onSearchInput() {
    if (this.searchword.length > 1) {
      this.showSpinner = true;

      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this._ebsWebServiceGlobals.getEbsWebServiceSearchURLParams() + this.searchword);
      this._ebsWebService.postData(this._ebsWebServiceGlobals.getEbsWebServiceSearchURL(), postPayloadObject).subscribe(res => {
        this.showSpinner = false;
        if (res.ViewType == "Detail") {
          this.navCtrl.push(Detail, {
            title: res.ListItemNavigation[0].ActionCaption,
            actionURL: res.ListItemNavigation[0].Action,
            postParams: res.ListItemNavigation[0].PostParameters
          });
        } else {
          this.navCtrl.push(GridBoxPage, {
            searchresult: res
          });
        }
      });

      /**
      this._ebsWebService.getData( this._ebsWebServiceGlobals.getEbsWebServiceSearchURL() + this.searchword).subscribe(res => {
        this.showSpinner = false;
        if (res.ListItemNavigation[0].ViewTypeAction == "Detail") {
          this.navCtrl.push(Detail, {
            title: res.ListItemNavigation[0].ActionCaption,
            actionURL: res.ListItemNavigation[0].Action
          });
        } else {
          this.navCtrl.push(GridBoxPage, {
            searchresult: res
          });
        }
      });**/

      setTimeout(function () {
        this.showSpinner = false;
      }, 10000)
    }
  }

  onSearchCancel() {
    this.searchword = "";
  }




}



// WEBPACK FOOTER //
// ./src/components/header/header.ts